import c from "../model/Visma.BusinessModel.Columns.json";
import r from "../model/Visma.BusinessModel.Relations.json";
import t from "../model/Visma.BusinessModel.Tables.json";
import type { Table, Column, Relation } from "~/model/Visma.BusinessModel";

export const tables = t as Table[];
export const columns = c as Column[];
export const relations = r as Relation[];
